import { computed, Ref, watch } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import type { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import { ListProductoAction } from "../../actions/productoActions";


export function useProductosList(params: Ref<PaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // 🔹 Query principal para listar productos
  const query = useQuery({
    queryKey: ["ProductosList", params],
    queryFn: () => ListProductoAction(params.value),
    staleTime: 60 * 1000, // cache de 1 minuto
  });

  // 🔹 Computed reactivos para acceder fácilmente a los datos
  const productos = computed(() => query.data.value?.data?.data?.productos || []);
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(() => query.data.value?.data?.data?.totalPages || 0);
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // 🔹 Prefetch cuando cambian los filtros o la paginación
  watch(
    params,
    (newParams) => {
      queryClient.prefetchQuery({
        queryKey: ["ProductosList", newParams],
        queryFn: () => ListProductoAction(newParams),
      });
    },
    { deep: true }
  );

  return {
    ...query, // => { data, isPending, isError, error, refetch, ... }
    productos,
    total,
    totalPages,
    currentPage,
  };
}
